import './Admin.css';

import { theme } from '@40seas/frontend/common/theme';
import { useAppStore } from '@40seas/frontend/dashboard/contexts';
import { CentralizedAnimatedLoader } from '@40seas/payments-shared';
import React, { Suspense } from 'react';
import { AdminContext } from 'react-admin';
import { LocalizationProvider } from '../../context/localizationContext';
import useInitAuthProvider from '../../hooks/useInitAuthProvider';
import useInitDataProvider from '../../hooks/useInitDataProvider';
import { i18nProvider } from '../../providers/i18nProvider';
import { localStorageProvider } from '../../providers/localStorageProvider';
import CommandMenuProvider from '../common/commandMenu/CommandMenuProvider';
import HubspotWidget from '../common/hubspot/HubspotWidget';
import { LayoutStrategy } from '../common/LayoutStrategy';
import { ModalsProvider } from '../common/modal/ModalsProvider';
import { ScrollToTop } from '../common/ScrollToTop';
import { TestModeAppBar } from '../common/TestModeAppBar';
import { InactivityPopup } from '../inactivityPopup/InactivityPopup';
import { ChatAssistantProvider } from './assistant/ChatAssistantProvider';
const AsyncResources = React.lazy(() => import('../common/AsyncResources'));

const store = localStorageProvider.getRaStore();

export const Admin = () => {
    const dataProvider = useInitDataProvider();
    const authProvider = useInitAuthProvider(dataProvider);
    const { basename, tenant, organization } = useAppStore();

    if (authProvider.isLoading) return <CentralizedAnimatedLoader />;

    // Based on https://marmelab.com/react-admin/Admin.html#unplugging-the-admin-using-admincontext-and-adminui

    return (
        <AdminContext
            key={tenant + organization?.id}
            basename={basename}
            theme={theme}
            dataProvider={dataProvider}
            authProvider={authProvider}
            i18nProvider={i18nProvider}
            store={store}
        >
            <ScrollToTop />
            <LocalizationProvider>
                <InactivityPopup />
                <ModalsProvider>
                    <LayoutStrategy>
                        <HubspotWidget>
                            <CommandMenuProvider>
                                <ChatAssistantProvider>
                                    <TestModeAppBar />
                                    <Suspense fallback={<CentralizedAnimatedLoader />}>
                                        <AsyncResources />
                                    </Suspense>
                                </ChatAssistantProvider>
                            </CommandMenuProvider>
                        </HubspotWidget>
                    </LayoutStrategy>
                </ModalsProvider>
            </LocalizationProvider>
        </AdminContext>
    );
};
